/**
 * Utility for persisting user's zipcode across sessions
 *
 * This helps improve UX by pre-filling the zipcode field for returning users,
 * while still allowing them to change it if needed.
 */

import { safeLocalStorage } from "./safeStorage";

const ZIPCODE_STORAGE_KEY = "user_zipcode";

/**
 * Save zipcode for future sessions
 */
export function saveZipcode(zipcode: string): void {
  if (zipcode && /^\d{5}$/.test(zipcode)) {
    safeLocalStorage.setItem(ZIPCODE_STORAGE_KEY, zipcode);
  }
}

/**
 * Get saved zipcode
 * Returns undefined if no zipcode is saved or if invalid
 */
export function getSavedZipcode(): string | undefined {
  const saved = safeLocalStorage.getItem(ZIPCODE_STORAGE_KEY);
  if (saved && /^\d{5}$/.test(saved)) {
    return saved;
  }
  return undefined;
}

/**
 * Clear saved zipcode
 */
export function clearSavedZipcode(): void {
  safeLocalStorage.removeItem(ZIPCODE_STORAGE_KEY);
}
